import React, { FC, useCallback, useContext, useEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import { Grid, Typography } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import { data, dataByUser } from './TransactionsTableLists'
import { TableSmall } from '../../../../../../components/Dashboard/TableSmall'
import { TableComponent } from '../../../../../../components/Dashboard/Table'
import { AppStateContext, useRefreshTransactions, useRest } from '../../../../../../components/Context'
import { routes } from '../../../../../../constants/routes'
import { userPermissionEnum } from '../../../../../../constants/userPermissions'

const useStyles = makeStyles((theme: Theme) => ({
  formWrap: {
    display: 'flex',
    width: '100%',
    height: '100%',
    flexDirection: 'column',
    paddingTop: theme.spacing(4),
  },
  container: {
    minHeight: 40,
    maxHeight: 40,
  },
  sectionWrap: {
    width: '100%',
    height: '100%',
    padding: theme.spacing(0, 4, 2, 4),
  },
}))

interface TransactionsSectionProps {
  title?: string
  userIdSf?: string
}

export const Transactions: FC<TransactionsSectionProps> = ({ title, userIdSf }) => {
  const formMethods = useForm({
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldFocusError: true,
  })
  const classes = useStyles()
  const { rxiosAuth } = useRest()
  const { getIsRefreshTransactions } = useContext(AppStateContext)
  const { saveIsRefreshTransactions } = useRefreshTransactions()
  // eslint-disable-next-line
  const [loading, setLoading] = useState<boolean>(false)
  // eslint-disable-next-line
  const [values, setValues] = useState<any>({})
  const [refresh, setRefresh] = useState<boolean | undefined>()
  const { getUserRole } = useContext(AppStateContext)
  // const [userRole, setUserRole] = useState<string | undefined>(getUserRole())
  const [userRole] = useState<string | undefined>(getUserRole())

  // useEffect(() => setUserRole(getUserRole()), [setUserRole, getUserRole])
  useEffect(() => setRefresh(getIsRefreshTransactions()), [setRefresh, getIsRefreshTransactions])

  const loadData = useCallback(
    async (page) => {
      let cleanupFunction = false
      setLoading(true)

      rxiosAuth
        .get(
          // eslint-disable-next-line no-nested-ternary
          // userIdSf
          //   ? `${data.requestByUser}/${userIdSf}?page=${page}&count=4`
          //   : userRole === userPermissionEnum.sole_trader
          //   ? `${dataByUser.request}?page=${page}&count=10`
          //   : `${data.request}?page=${page}&count=4`,
          userRole === userPermissionEnum.sole_trader
            ? `${dataByUser.request}?page=${page}&count=10`
            : `${data.request}?page=${page}&count=4`,
        )
        .subscribe(
          // eslint-disable-next-line
          (next: any) => {
            setValues(next)
            if (!cleanupFunction) setLoading(false)
          },

          (error: Error) => {
            toast.error(error?.message || error)
            setLoading(false)
          },

          () => {
            setLoading(false)
            saveIsRefreshTransactions(false)
          },
        )
      cleanupFunction = true
    },
    // eslint-disable-next-line
    [rxiosAuth, userIdSf],
  )

  useEffect(
    () => {
      ;(async () => {
        await loadData('1')
      })()
    }, // eslint-disable-next-line
    [],
  )

  useEffect(() => {
    if (refresh) {
      ;(async () => {
        await loadData('1')
      })()
    }
    // eslint-disable-next-line
  }, [refresh])

  return (
    <Grid item xs={12} className={classes.formWrap}>
      <FormProvider {...formMethods}>
        <Grid item xs={12} className={classes.container}>
          {title ? <Typography variant={'h6'}>{title}</Typography> : ' '}
        </Grid>

        <Grid item xs={12} className={classes.sectionWrap}>
          {userRole === userPermissionEnum.sole_trader ? (
            <TableComponent
              columns={dataByUser.columns}
              data={values.items}
              params={values.meta}
              // eslint-disable-next-line
              loadData={(pageNumber: string | number) => loadData(pageNumber)}
              loading={loading}
            />
          ) : (
            <TableSmall
              columns={data.columns}
              data={values.items}
              params={values.meta}
              // eslint-disable-next-line
              loadData={(pageNumber: string | number) => loadData(pageNumber)}
              viewAll
              viewAllLink={
                userIdSf ? routes.VIEW_ALL_TRANSACTIONS_BY_ID.replace(':id', userIdSf) : routes.VIEW_ALL_TRANSACTIONS
              }
              loading={loading}
            />
          )}
        </Grid>
      </FormProvider>
    </Grid>
  )
}
